import { render, staticRenderFns } from "./_base-user-avatar.vue?vue&type=template&id=4fb56015&scoped=true&"
import script from "./_base-user-avatar.vue?vue&type=script&lang=js&"
export * from "./_base-user-avatar.vue?vue&type=script&lang=js&"
import style0 from "./_base-user-avatar.vue?vue&type=style&index=0&id=4fb56015&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb56015",
  null
  
)

export default component.exports